import { useContext } from 'react';
import { PlaygroundContext } from '../contexts/PlaygroundContext';

const usePlaygroundContext = () => useContext(PlaygroundContext);

export default usePlaygroundContext;